import { Header } from '../../../../../components/atoms/header/header';
import { useRenderContext } from '../../../context/render-context';

import { AnswerElement } from './elements/answer-element';
import { StatusIcon } from './icons/icons';
import { ICompositeQABlock } from './types';

const EmptyState = ({ title }: { readonly title: string }) => (
  <div className="bg-white p-4 rounded-lg">
    <div className="flex items-start mb-4">
      <div className="mr-3 mt-1 flex-shrink-0">
        <StatusIcon hasAnswer={false} />
      </div>
      <div className="flex-1">
        <Header className="text-left text-black font-bold underline" level="h2">
          {title}
        </Header>
      </div>
    </div>
  </div>
);

const CompositeQABlock = ({
  detailed = 'false',
  selectedQuestions = [],
  title = 'Composite QA Block',
  truncateTo = 0,
  link,
  externalLink,
}: ICompositeQABlock) => {
  const { survey, answers } = useRenderContext();
  if (!survey) return <div>No survey</div>;
  if (!answers) return <div>No answers</div>;
  if (selectedQuestions && selectedQuestions.length > 0) {
    return (
      <div className="flex flex-col mt-2 mt-0FirstInDropZone">
        <AnswerElement
          answers={answers}
          detailed={detailed}
          externalLink={externalLink}
          link={link}
          selectedQuestions={selectedQuestions}
          survey={survey}
          title={title}
          truncateTo={truncateTo}
        />
      </div>
    );
  }

  return <EmptyState title={title} />;
};

export { CompositeQABlock };
